const read_env_value = (value) => {
    return String(value || '').trim().replace(/^['"]|['"]$/g, '');
};

const trim_trailing_slash = (url) => {
    return read_env_value(url).replace(/\/+$/, '');
};

const compose_frontend_url = (protocol, host, port) => {
    const normalizedProtocol = read_env_value(protocol);
    const normalizedHost = read_env_value(host);
    const normalizedPort = read_env_value(port);

    if (!normalizedProtocol.length || !normalizedHost.length) {
        return '';
    }

    return trim_trailing_slash(`${normalizedProtocol}${normalizedHost}${normalizedPort}`);
};

const server = read_env_value(process.env.REACT_APP_SERVER).toUpperCase() || 'PRODUCTION';
const runtimeOrigin = typeof window !== 'undefined' ? trim_trailing_slash(window.location.origin) : '';
const frontendUrl = trim_trailing_slash(process.env.REACT_APP_FRONTEND_URL) || runtimeOrigin || 'http://localhost:5888';
const ecosystemAuthFrontendUrl = compose_frontend_url(
    process.env.REACT_APP_ERISED_FRONTEND_PROTOCOL,
    process.env.REACT_APP_ERISED_FRONTEND_HOST,
    process.env.REACT_APP_ERISED_FRONTEND_PORT
) || trim_trailing_slash(process.env.REACT_APP_ERISED_FRONTEND_URL);
const fallbackAuthFrontendByServer = server === 'STAGING'
    ? 'https://portal.doitforme.club'
    : server === 'PRODUCTION'
        ? 'https://portal.doitforme.eu'
        : 'http://localhost:5600';
const authFrontendUrl = trim_trailing_slash(process.env.REACT_APP_AUTH_FRONTEND_URL)
    || ecosystemAuthFrontendUrl
    || fallbackAuthFrontendByServer;
const ecosystemErisedBackendUrl = compose_frontend_url(
    process.env.REACT_APP_ERISED_BACKEND_PROTOCOL,
    process.env.REACT_APP_ERISED_BACKEND_HOST,
    process.env.REACT_APP_ERISED_BACKEND_PORT
) || trim_trailing_slash(process.env.REACT_APP_ERISED_BACKEND_URL);
const fallbackErisedBackendByServer = server === 'STAGING'
    ? 'https://backend.portal.doitforme.club'
    : server === 'PRODUCTION'
        ? 'https://backend.portal.doitforme.eu'
        : 'http://localhost:56000';
const erisedBackendUrl = ecosystemErisedBackendUrl || fallbackErisedBackendByServer;
const ecosystemCerebroBackendUrl = compose_frontend_url(
    process.env.REACT_APP_CEREBRO_BACKEND_PROTOCOL,
    process.env.REACT_APP_CEREBRO_BACKEND_HOST,
    process.env.REACT_APP_CEREBRO_BACKEND_PORT
) || trim_trailing_slash(process.env.REACT_APP_CEREBRO_BACKEND_URL);
const fallbackCerebroBackendByServer = server === 'STAGING'
    ? 'https://backend.tasks.doitforme.club'
    : server === 'PRODUCTION'
        ? 'https://backend.tasks.doitforme.eu'
        : 'http://localhost:50020';
const cerebroBackendUrl = ecosystemCerebroBackendUrl || fallbackCerebroBackendByServer;
const cerebroFrontendUrl = compose_frontend_url(
    process.env.REACT_APP_CEREBRO_FRONTEND_PROTOCOL,
    process.env.REACT_APP_CEREBRO_FRONTEND_HOST,
    process.env.REACT_APP_CEREBRO_FRONTEND_PORT
) || trim_trailing_slash(process.env.REACT_APP_CEREBRO_FRONTEND_URL)
    || (server === 'STAGING' ? 'https://tasks.doitforme.club' : server === 'PRODUCTION' ? 'https://tasks.doitforme.eu' : 'http://localhost:5902');
const fallbackDoloresBackendByServer = server === 'STAGING'
    ? 'https://backend.hr.doitforme.club'
    : server === 'PRODUCTION'
        ? 'https://backend.hr.doitforme.eu'
        : 'http://localhost:51230';
const doloresBackendUrl = trim_trailing_slash(process.env.REACT_APP_DOLORES_BACKEND_URL)
    || fallbackDoloresBackendByServer;
const keycloakEnabled = read_env_value(process.env.REACT_APP_KEYCLOAK_ENABLED).toLowerCase() === 'true';
const usesCentralAuth = authFrontendUrl !== frontendUrl;

export const config = {
    appName: process.env.REACT_APP_NAME || '__PROJECT_DISPLAY__',
    projectSlug: 'godfather',
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:58890',
    erisedBackendUrl,
    ERISED_BACKEND_URL: erisedBackendUrl,
    cerebroBackendUrl,
    cerebro: cerebroFrontendUrl,
    CEREBRO_BACKEND_URL: cerebroBackendUrl,
    doloresBackendUrl,
    DOLORES_BACKEND_URL: doloresBackendUrl,
    BACKEND_URL: doloresBackendUrl,
    frontendUrl,
    authFrontendUrl,
    keycloakEnabled,
    usesCentralAuth,
    shouldUseKeycloak: keycloakEnabled || usesCentralAuth,
    server,
    offerV3Enabled: process.env.REACT_APP_OFFER_V3_ENABLED === 'true',
    niffler: trim_trailing_slash(process.env.REACT_APP_NIFFLER_FRONTEND_URL) || (server === 'STAGING' ? 'https://leads.doitforme.club' : 'https://leads.doitforme.eu'),
    payment: {
        bankName: process.env.REACT_APP_PAYMENT_BANK_NAME || '',
        accountHolder: process.env.REACT_APP_PAYMENT_ACCOUNT_HOLDER || '',
        iban: process.env.REACT_APP_PAYMENT_IBAN || ''
    },
    keycloak: {
        url: process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.doitforme.club/',
        realm: process.env.REACT_APP_KEYCLOAK_REALM || 'Doitforme',
        clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'erised-web-app'
    }
};

const clientUrls = {
    erised: config.authFrontendUrl,
    godfather: config.frontendUrl,
    griphook: process.env.REACT_APP_GRIPHOOK_FRONTEND_URL || 'https://app.doitforme.eu',
    dailyprofit: process.env.REACT_APP_DAILYPROFIT_FRONTEND_URL || 'https://questad.doitforme.eu',
    dolores: config.frontendUrl,
    hr: process.env.REACT_APP_DOLORES_FRONTEND_URL || 'https://hr.doitforme.eu',
    syrax: process.env.REACT_APP_SYRAX_FRONTEND_URL || '',
    whitecastle: process.env.REACT_APP_WHITECASTLE_FRONTEND_URL || '',
    lois: process.env.REACT_APP_LOIS_FRONTEND_URL || 'https://adsnap.doitforme.eu'
};

const clientConfig = {
    ...clientUrls,
    ...config
};

export default clientConfig;
